import React, { ButtonHTMLAttributes, ReactNode } from 'react';
import cx from 'classnames';

import s from './BRadio.module.scss';

export interface BRadioProps extends ButtonHTMLAttributes<HTMLInputElement> {
  className?: string;
  checked?: boolean;
  disabled?: boolean;
  label?: string | ReactNode;
}

export const BRadio = (props: BRadioProps) => {
  const {
    checked,
    label,
    disabled,
    className,
    ...otherProps
  } = props;

  const additional = [
    className,
  ];

  const mods = {
    [s.disabled]: disabled,
  };

  return (
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    <label className={cx(s.bRadio, mods, additional)}>
      <div className={s.bRadioInner}>
        <input
          className={s.bRadioInput}
          type="radio"
          checked={checked}
          disabled={disabled}
          hidden
          {...otherProps}
        />
        <span className={s.bRadioChecked} />
      </div>
      {label && <span className={s.bRadioLabel}>{label}</span>}
    </label>
  );
};
